import { useQuery } from '@tanstack/react-query'
import { getSession } from '@/lib/auth-client'

export function useCurrentUser() {
  const {
    data: currentUser,
    isLoading: isLoadingUser,
    error: errorUser,
  } = useQuery({
    queryKey: ['current-user'],
    queryFn: async () => {
      const { data } = await getSession()
      return data?.user ?? null
    },
  })

  return {
    currentUser: currentUser ?? null,
    isLoading: isLoadingUser,
    error: errorUser,
  }
}
